import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import { dsColorNew } from '@palette'

import AppLinearProgress from './LinearProgress'


// The running state of a table row: the Real Time progress card (spinner, bar, done/total) and its hint
// underneath; clicking it opens the searches detail. `label` keeps a word the row already showed (Running…).
export default function AppRunProgress({ actual, total, done, totalText, generating, label, hint = 'Click progress bar to view details', onClick, ...props }) {
	return <Box sx={{ cursor: !generating ? 'pointer' : '', width: 1, minWidth: 230, maxWidth: 280 }} onClick={onClick} {...props}>
		<Box sx={{
			display: 'flex', alignItems: 'center', gap: 1, px: 1.25, py: 0.75,
			backgroundColor: dsColorNew.white, border: `1px solid ${dsColorNew.grayBorder}`, borderRadius: '10px',
		}}>
			<CircularProgress size={12} thickness={5} sx={{ color: dsColorNew.appBlue, flexShrink: 0 }}/>
			{!!label && <Box sx={{ fontSize: 12, fontWeight: 600, color: dsColorNew.textTitle, whiteSpace: 'nowrap' }}>{label}</Box>}
			<AppLinearProgress
				actual={actual}
				total={total}
				generating={generating}
				progressBarProps={{ height: 6, borderRadius: 3, '& .MuiLinearProgress-bar': { borderRadius: 3 } }}
			/>
			{!generating && <Box sx={{ fontSize: 12, color: dsColorNew.textMuted, whiteSpace: 'nowrap' }}>
				{done || 0}/{totalText || 0}
			</Box>}
		</Box>
		<Box sx={{ fontSize: '0.7rem', color: dsColorNew.textMuted, textAlign: 'center', mt: 0.5 }}>
			{generating ? 'Generating' : hint}
		</Box>
	</Box>
}
